import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  absolute: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(3),
    color: '#ffffff',
  },
  footerModalAction: {
    borderTop: '1px solid #ccc',
  },
  DialogContent: {
    paddingTop: '1%',
    paddingBottom: '2%',
  },
  servicioSeleccionado: {
    border: '2px solid red',
    color: 'red',
  },
  widthTitle: {
    width: '80%',
  },
  btnVuelta: {
    float: 'right !important',
    color: 'white !important',
  },
  floatLeft: {
    float: 'left',
  },
  button: {
    color: '#ffffff',
  },
  titleDialog: {
    background: '#01579b',
    color: '#ffffff',
  },
  footerModalAction: {
    borderTop: '1px solid #ccc',
    borderBottom: '10px solid #01579b',
  },
  formControl: {
    minWidth: '100%',
  },
}));
